var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup99(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F1F3F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5001 22.4583V17.625H16.4167V39.375H40.5834V22.4583H28.5001ZM21.2501 36.9583H18.8334V34.5417H21.2501V36.9583ZM21.2501 32.125H18.8334V29.7083H21.2501V32.125ZM21.2501 27.2917H18.8334V24.875H21.2501V27.2917ZM21.2501 22.4583H18.8334V20.0417H21.2501V22.4583ZM26.0834 36.9583H23.6667V34.5417H26.0834V36.9583ZM26.0834 32.125H23.6667V29.7083H26.0834V32.125ZM26.0834 27.2917H23.6667V24.875H26.0834V27.2917ZM26.0834 22.4583H23.6667V20.0417H26.0834V22.4583ZM38.1667 36.9583H28.5001V34.5417H30.9167V32.125H28.5001V29.7083H30.9167V27.2917H28.5001V24.875H38.1667V36.9583ZM35.7501 27.2917H33.3334V29.7083H35.7501V27.2917ZM35.7501 32.125H33.3334V34.5417H35.7501V32.125Z",
    fill: "#A8B6C1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup99);
export default __webpack_public_path__ + "static/media/Group99.60e17fd7.svg";
export { ForwardRef as ReactComponent };